module.exports = __webpack_public_path__ + "img/outdoor-border.51ce765b.png";